import React from "react";

// Whether the sidebar is shrunk to its icon bar right now, for the parts
// that hide their text then.
const SidebarContext = React.createContext({ collapsed: false });

// Text that fades out while the sidebar is an icon bar. `shown` is the
// opacity it has otherwise.
export function useSidebarFade(shown = 1) {
  const { collapsed } = React.useContext(SidebarContext);
  return { opacity: collapsed ? 0 : shown, transition: "opacity 150ms ease" };
}

export default SidebarContext;
